import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'ANTEPRIMA',
        description: "Qui vedi il testo integrale dell'esercizio e la soluzione se presente. Trovi il pulsante per modificarlo o per duplicarlo.",
        isActive: true,
        name: 'Preview',
        tutorialName: 'crea-verifica_anteprima-esercizio-docente'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 20,
        yOffset: 20
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 20,
        yOffset: 20
    },
    pages: ['#/search/user', '#/search/user/']
};
